export const PasswordValidateField = (values) => {
    let errors = {}
    if (!values?.email) {
        errors.email = "Email field is required.";
    } else if (!/\S+@\S+\.\S+/.test(values?.email)) {
        errors.email = "Invalid email format. Please provide a valid email address.";
    }

    // OTP field
    if (!values?.otp) {
        errors.otp = "OTP field is required.";
    } else if (!/^[0-9]{6}$/.test(values?.otp)) {
        errors.otp = "Invalid OTP format. Please provide a valid OTP.";
    }

    // Password field
    if (!values?.password) {
        errors.password = "Password field is required.";
    } else if (values?.password?.length < 8) {
        errors.password = "Password must be at least 8 characters long.";
    }

    // Confirm Password field
    if (!values?.confirmpassword) {
        errors.confirmpassword = "Confirm Password field is required.";
    } else if (values?.confirmpassword !== values?.password) {
        errors.confirmpassword = "Confirm Password does not match with Password.";
    }

    return errors;
}